export enum InsuranceHistoricalFieldsEnum {
	IsEligible = 'IsEligible'
}